export default class FKegiatanTeam {
  constructor(
    id,
    fkegiatanBean,
    fpegawaiBean,
    type,

    created,
    modifiedBy
  ) {
    this.id = id;
    this.fkegiatanBean = fkegiatanBean;
    this.fpegawaiBean = fpegawaiBean;
    this.type = type;

    this.created = created;
    this.modifiedBy = modifiedBy;
  }

}
